import { createAsyncThunk } from '@reduxjs/toolkit';
import franchiseApi from '~/apis/franchise';
import { CREATE_FRANCHISE, GET_FRANCHISE, GET_FRANCHISE_DETAIL, UPDATE_FRANCHISE } from '~/utils/constants/actionType';
import {
  ICreateFranchise,
  IParamsGetFranchise,
  IReponseFranchiseDetail,
  IResponseGetFranchise,
} from '~/utils/interface/franchise';

export const handleCreateFranchise = createAsyncThunk<null, ICreateFranchise>(
  CREATE_FRANCHISE,
  async (data: ICreateFranchise, { rejectWithValue }) => {
    try {
      const res = await franchiseApi.createFranchise(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetFranchise = createAsyncThunk<IResponseGetFranchise, IParamsGetFranchise>(
  GET_FRANCHISE,
  async (params: IParamsGetFranchise = {}, { rejectWithValue }) => {
    try {
      const res = await franchiseApi.getFranchise(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetFranchiseDetail = createAsyncThunk<IReponseFranchiseDetail, string>(
  GET_FRANCHISE_DETAIL,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await franchiseApi.getFranchiseDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateFranchise = createAsyncThunk<null, { id: string | undefined; data: ICreateFranchise }>(
  UPDATE_FRANCHISE,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await franchiseApi.updateFranchise(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
